module.exports = __webpack_public_path__ + "static/media/mBG6.bcf27854.jpg";